import * as React from 'react';

import { SelectControl } from 'types/state';

import { DropdownWrapper } from './dropdownWrapperComponents';
import { DropdownLabel } from './dropdownLabelComponents';
import { DropdownPopup } from './dropdownPopupComponents';
import { SelectBox } from 'design/selectBox';

export function Dropdown<ValueType extends string>(
  props: SelectControl<ValueType>
) {
  const { options, selectedValue, onSelectValue } = props;

  const [opened, setOpened] = React.useState(false);

  const handleOutsideClick = React.useCallback(() => {
    setOpened(false);
  }, []);

  const handleLabelClick = React.useCallback(() => {
    setOpened((prev) => !prev);
  }, []);

  const handleSelect = React.useCallback(
    (value) => {
      onSelectValue(value);
      setOpened(false);
    },
    [onSelectValue]
  );

  const labelText = React.useMemo(() => {
    return options.reduce((acc, { value, title }) => {
      if (selectedValue === value) {
        return title || value;
      }
      return acc;
    }, '');
  }, [options, selectedValue]);

  return (
    <DropdownWrapper opened={opened} onOutsideClick={handleOutsideClick}>
      <DropdownLabel onClick={handleLabelClick} text={labelText} />
      <DropdownPopup>
        {opened && (
          <SelectBox
            options={options}
            onSelectValue={handleSelect}
            selectedValue={selectedValue}
          />
        )}
      </DropdownPopup>
    </DropdownWrapper>
  );
}
